import type { FC } from "react"
import { Link } from "react-router-dom"

import styles from "./CompanyBreadcrumb.module.scss"

type CompanyBreadcrumbProps = {
	companyName: string
	companyId: string
	isEditPage?: boolean
}

const CompanyBreadcrumb: FC<CompanyBreadcrumbProps> = ({
	companyName,
	companyId,
	isEditPage,
}) => {
	return (
		<nav className={styles.breadcrumb}>
			<Link to="/souhl_admin" className={styles.breadcrumbLink}>
				会社
			</Link>
			<span className={styles.separator}>/</span>
			{isEditPage ? (
				<Link
					to={`/souhl_admin/companies/${companyId}`}
					className={styles.breadcrumbLink}
				>
					{companyName}
				</Link>
			) : (
				<span className={styles.breadcrumbCurrent}>{companyName}</span>
			)}
			{isEditPage && (
				<>
					<span className={styles.separator}>/</span>
					<span className={styles.breadcrumbCurrent}>編集</span>
				</>
			)}
		</nav>
	)
}

export default CompanyBreadcrumb
